import { uploadCroppedImage } from "../common/file_upload";

jQuery(function ($) {
  "use strict";

  // イベントの募集を締め切るか確認
  $("#member-close-recruiting-form").submit(function (e) {
    if (!confirm("このイベントのメンバー募集を締め切りますか？")) {
      e.preventDefault();
    }
  });

  // コメントの削除をするか確認
  $("form#comment_destroy_form").submit(function (e) {
    if (!confirm("このコメントを削除しますか？")) {
      e.preventDefault();
    }
  });

  // マイルストーンの表示
  $('#start_date').on('change', function () {
    $('#milestone').text($(this).val().replaceAll('-', '/'));
  }).trigger('change');

  // 企業連携ありの場合のフィールド表示
  $('input[name="is_company_integration"]').on('change', function () {
    const isCompanyIntegration = ($('input[name="is_company_integration"]:checked').val() ?? $(this).val()) === '1';
    $('.has_company_integration').toggle(isCompanyIntegration);
  }).trigger('change');

  // 開催場所でその他選択時
  $('input[name="pavilion_id"]').on('change', function () {
    const isSelectOther = $('input[name="pavilion_id"]:checked').val() === '0';
    $('.input_pavilion_other').prop('disabled', !isSelectOther);
    $('.input_pavilion_other_group').toggle(isSelectOther);
  }).trigger('change');

  // 対象のチェックをONで人数を入力可能にする
  $('input[name^="target["]').on('change', function () {
    const name = $(this).attr('name');
    let column = name.substr(name.indexOf('[') + 1);
    column = column.substr(0, column.indexOf(']'));
    $(`input[name="target_min[${column}]"`).prop('disabled', !$(this).prop('checked'));
    $(`input[name="target_max[${column}]"`).prop('disabled', !$(this).prop('checked'));
    $(`input[name="target_no_limit[${column}]"`).prop('disabled', !$(this).prop('checked'));
  }).trigger('change');

  // 人数を入力で制限なしのチェックをOFFにする
  $('input[name^="target_max["]').on('change', function () {
    const name = $(this).attr('name');
    let column = name.substr(name.indexOf('[') + 1);
    column = column.substr(0, column.indexOf(']'));
    $(`input[name="target_no_limit[${column}]"`).prop('checked', $(this).val() === '0');
  }).trigger('change');

  // 制限なしのチェックをONで0人にする
  $('input[name^="target_no_limit["]').on('change', function () {
    const name = $(this).attr('name');
    let column = name.substr(name.indexOf('[') + 1);
    column = column.substr(0, column.indexOf(']'));
    if ($(this).is(':checked')) {
      $(`input[name="target_max[${column}]"`).val(null);
    }
  }).trigger('change');

  //希望職種が希望なしだった場合入力できなくする
  $('input[name="want_company_industry"]').on('change', function () {
    const wantCompanyIndustry = $('input[name="want_company_industry"]:checked').val();
    $('select[name="company_industry_id"]').prop('disabled', wantCompanyIndustry === '0');
    $('input[name="company_industry_preference"]').prop('disabled', wantCompanyIndustry === '0');
  }).trigger('change');

  //希望ゲストが希望なしだった場合入力できなくする
  $('input[name="want_guest_speaker"]').on('change', function () {
    const wantGuestSpeaker = $('input[name="want_guest_speaker"]:checked').val();
    $('input[name="guest_speaker_preference"]').prop('disabled', wantGuestSpeaker === '0');
  }).trigger('change');

  //希望予算が希望なしだった場合入力できなくする
  $('input[name="want_budget"]').on('change', function () {
    const wantBudget = $('input[name="want_budget"]:checked').val();
    $('input[name="budget_amount"]').prop('disabled', wantBudget === '0');
    $('input[name="budget_preference"]').prop('disabled', wantBudget === '0');
  }).trigger('change');

  //コメント編集のoverflow-yを一番下から表示する
  const commentArea = $('#commentArea');
  if (commentArea.length) {
    const scrollHeight = commentArea[0].scrollHeight;
    commentArea.scrollTop(scrollHeight);
  }

  // サムネイル画像アップロード
  $('#event_thumbnail_image_form').on('change', function () {
    uploadCroppedImage($(this), '/company/event/upload-image', 'event_thumbnail_image', 16 / 9);
  });

  // 添付画像1,2,3アップロード
  $('#event_image_form_0').on('change', function () {
    uploadCroppedImage($(this), '/company/event/upload-image', 'eventImage_0', 16 / 9);
  });
  $('#event_image_form_1').on('change', function () {
    uploadCroppedImage($(this), '/company/event/upload-image', 'eventImage_1', 16 / 9);
  });
  $('#event_image_form_2').on('change', function () {
    uploadCroppedImage($(this), '/company/event/upload-image', 'eventImage_2', 16 / 9);
  });

  // 添付画像の削除
  $('.delete-img-button').on('click', function() {
    var index = $(this).data('index');
    $(`#eventImage_${index}`).attr('src', '').addClass('hidden');
    $(`#event_image_form_${index}`).val('');
    $(`#cropped_eventImage_${index}`).val('');
    $(this).closest('.event-image-wrapper').addClass('hidden');
  });

  // 検索条件（承認ステータス）
  $('#event_status_examining').on('change', function () {
    $('input[name="event_application[status][]"]').prop('disabled', !$(this).prop('checked'));
  }).trigger('change');

  // 参加審査編集モーダル
  $('.show_event_entry_status_modal').on('click', function () {
    const action = $(this).parent().find('input[name^="event_member_entry"][name$="[action]"]').val();
    const status = $(this).parent().find('input[name^="event_member_entry"][name$="[status]"]').val();
    $('#update_entry_status_form').attr('action', action);
    $('input[name="event_member_entry[status]"]').each(function (e) {
      $(this).prop('checked', $(this).val() === status);
    });
  });

  // お気に入りアイコン押下
  $('#event_favorite_icon').on('click', function () {
    const form = $(this).parents('form');
    const favoriteIcon = $(this).find('span');
    $.ajax({
      url: form.attr('action'),
      method: 'GET',
    }).done(function (response) {
      const isFavorite = $('#isFavorite').val();
      favoriteIcon.text(isFavorite === '0' ? 'favorite' : 'favorite_border');
      $('#isFavorite').val(isFavorite === '0' ? '1' : '0');
    }).fail(function (jqXHR, textStatus, errorThrown) {
      console.log(jqXHR.status + ' : ' + errorThrown);
      console.log(jqXHR.responseText);
    });
  });

  // コメントいいね機能
  $('.comment_favorite_icon').on('click', function () {
    const form = $(this).parents('form');
    const favoriteIcon = $(this).find('span');
    const isCommentFavorite = $(this).find('input');

    $.ajax({
      url: form.attr('action'),
      method: 'GET',
    }).done(function (response) {
      favoriteIcon.text(isCommentFavorite.val() === '0' ? 'favorite' : 'favorite_border');
      isCommentFavorite.val(isCommentFavorite.val() === '0' ? '1' : '0');
    }).fail(function (jqXHR, textStatus, errorThrown) {
      console.log(jqXHR.status + ' : ' + errorThrown);
      console.log(jqXHR.responseText);
    });
  });
});
